import { BoxTogglerService } from '../services/box-toggler.service';

interface SectionToggleScope extends ng.IScope {
  init         : () => void;
  open         : any;
  sectionToggle: string;
  toggle       : ( evt ?: JQuery.ClickEvent ) => void;
}

export function SectionToggleDirective (
  $timeout     : ng.ITimeoutService,
  boxTogglerApi: BoxTogglerService
) : ng.IDirective {

  function link ( scope : SectionToggleScope, element : ng.IRootElementService ) : void {
    scope.init = function () {
      element.on('click', scope.toggle);

      if (!scope.open) {
        const contentElement = boxTogglerApi.getContentElement(scope.sectionToggle);

        $timeout(() => boxTogglerApi.close(element, contentElement, true));
      }
    };

    scope.toggle = function ( evt : JQuery.ClickEvent ) {
      const contentElement = boxTogglerApi.getContentElement(scope.sectionToggle);

      if (evt) {
        evt.stopPropagation();
      }

      scope.open = !scope.open;

      if (scope.open) {
        boxTogglerApi.open(element, contentElement);
      }
      else {
        boxTogglerApi.close(element, contentElement);
      }

      scope.$emit('toggled');
    };

    scope.$on('$destroy', () => {
      element.off('click', scope.toggle);
    });

    scope.$on('close', evt => {
      if (scope.open) {
        scope.toggle();
      }
    });

    scope.$on('open', evt => {
      if (!scope.open) {
        scope.toggle();
      }
    });

    scope.$on('toggle', evt => {
      scope.toggle();
    });

    scope.init();
  }

  return {
    link,
    restrict: 'A',
    scope   : {
      sectionToggle: '@',
      open         : '@'
    }
  };
}